import React, { Component } from 'react';
// redux
import { connect } from 'react-redux';
import { deleteUserSupport } from '../../../redux/reducers/auth';

// components
import Button from '../../../components/Button/Button';
// utils
import { toast } from 'react-toastify';
import { toastResponseErrors } from '../../../utils/response';
// styles
import styles from './DeleteAccountModal.mod.css';

class DeleteUserSupportModal extends Component {
  deleteUserSupport = () => {
    const {
      closeModal,
      deleteUserSupport,
      user: { id },
    } = this.props;

    deleteUserSupport(id)
      .then(() => {
        closeModal();
        toast.info('You support person successfully removed!');
      })
      .catch(toastResponseErrors);
  };

  render() {
    const { closeModal } = this.props;

    return (
      <div className={styles.wrapper}>
        <h2>
          Do you really want to completely delete your account? You can’t undo
          this operation.
        </h2>
        <br />
        <div className={styles.buttons}>
          <Button link onClick={closeModal}>
            Close
          </Button>
          <Button type="submit" primary onClick={this.deleteUserSupport}>
            Delete
          </Button>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    user: state.auth.user,
  }),
  { deleteUserSupport }
)(DeleteUserSupportModal);



// WEBPACK FOOTER //
// ./src/containers/UserProfile/components/DeleteUserSupportModal.jsx